// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld/base/core';
import 'myWorld/layers/mywVectorLayer';
import 'myWorld/features/featureRepresentation';

/**
 * Layer where myWorld features are rendered using vectors and with a labeled that displayed when the user hovers the mouse over the vector
 * @name MywVectorLayerLabeled
 * @constructor
 * @extends {MywVectorLayer}
 */
myw.MywVectorLayerLabeled = myw.MywVectorLayer.extend({
    /**
     * Creates and returns a representation for a feature
     * @param  {Feature} feature [description]
     * @return {FeatureRepresentation}
     */
    createRepForFeature(feature) {
        const rep = myw.MywVectorLayer.prototype.createRepForFeature.apply(this, arguments);
        if (!rep) return;

        // we don't want the labels to be displayed on touch events
        if (!myw.isTouchDevice) rep.bindTooltip(this.getLabelTextFor(feature));

        return rep;
    },

    /**
     * Text to use as label for a feature
     * @param  {Feature} feature
     * @return {string}      The text to use as label
     */
    getLabelTextFor(feature) {
        return `${feature.getTitle()} - ${feature.getShortDescription()}`;
    }
});

export default myw.MywVectorLayerLabeled;
